var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6C13.6568 6 15 4.65683 15 3C15 1.34314 13.6568 0 12 0C10.6022 0 9.42758 0.956078 9.0945 2.25H0.75C0.33579 2.25 0 2.58579 0 3C0 3.41422 0.33579 3.75 0.75 3.75H9.0945C9.42758 5.0439 10.6022 6 12 6ZM10.5 3C10.5 3.82843 11.1716 4.5 12 4.5C12.8285 4.5 13.5 3.82843 13.5 3C13.5 2.17157 12.8285 1.5 12 1.5C11.1716 1.5 10.5 2.17157 10.5 3ZM0 9C0 7.34317 1.34315 6 3 6C4.39788 6 5.57245 6.9561 5.90549 8.25H14.25C14.6642 8.25 15 8.58578 15 9C15 9.41422 14.6642 9.75 14.25 9.75H5.90549C5.57245 11.0439 4.39788 12 3 12C1.34315 12 0 10.6568 0 9ZM4.5 9C4.5 8.17155 3.82843 7.5 3 7.5C2.17157 7.5 1.5 8.17155 1.5 9C1.5 9.82845 2.17157 10.5 3 10.5C3.82843 10.5 4.5 9.82845 4.5 9Z",
    fill: "#83899B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.5cc6b4eaa7b244e1a87215bea6f917d7.svg";
export { ForwardRef as ReactComponent };